import Columns from './column-names.json';

import CongressData from './congress-demographics.json';
import StUpperData from './statelegupper-demographics.json';
import StLowerData from './stateleglower-demographics.json';

//This is for legislative district (congress,st upper, st lower) data ONLY. See TractDemoArrayManager.js for tract level data manager
export default class DemoArrayManager {
    constructor(config) {
        this.loading = true;
        this.columns = Columns.array;
        this.columnObj = Columns.obj;
        this.config = config;
        this.loading = false;
    }

    ColToIdx(columnName) {
        return this.columns.indexOf(columnName);
    }

    IdxToCol(idx) {
        return this.columns[idx];
    }

    GetDistrictData(_geoid, _districtType) {
        this.loading = true;
        let data;
        switch (_districtType) {
            case this.config.enums.LEG_BODY.CONGRESS:
                data = CongressData;
                break;
            case this.config.enums.LEG_BODY.ST_UPPER:
                data = StUpperData;
                break;
            case this.config.enums.LEG_BODY.ST_LOWER:
                data = StLowerData;
                break;
        }
        if(data.length > 0){
            return this.ArrayToObj(data.filter(d => d[0] === _geoid));
        }
        this.loading = false;
        return {}
    }

    GetDistrictArr(_geoid, _districtType) {
        let data;
        switch (_districtType) {
            case this.config.enums.LEG_BODY.CONGRESS:
                data = CongressData;
                break;
            case this.config.enums.LEG_BODY.ST_UPPER:
                data = StUpperData;
                break;
            case this.config.enums.LEG_BODY.ST_LOWER:
                data = StLowerData;
                break;
        }
        return data.filter(d => d[0] === _geoid);
    }

    ArrayToObj(arr) {
        let obj = {}
        this.columns.forEach((element, idx) => {
            if (arr && arr.length > 0) {
                obj[element] = arr[0][idx];
            }
        });
        this.loading = false;
        return obj;
    }
}